import React, { useEffect, useState } from "react";
import "./FormVehicle.css";
import "./FormVehicleOverview.css";
import { makeStyles } from "@material-ui/core";
import { convertProperty } from "../../propertyconverter";

const QUOTE_SAVED_SUCCESS_MSG = "ok";

const useStyles = makeStyles((theme) => ({

  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    width: "100%",
  },

}));

function FormVehicleOverview({ nextStep, prevStep, formHeading, showFailPage, quote, vehicleList, addRemoveVehicle }) {

  const [numberOfVehicles, setNumberOfVehicles] = useState("");

  const classes = useStyles();

  const formatFitments = (fitments) => {
    const fitmentArray = fitments.split(", ")
    var fitmentDescription = "";
    if (fitmentArray.length < 2) {
      fitmentDescription = fitmentArray.length + " Fitment";
    } else {
      fitmentDescription = fitmentArray.length + " Fitments";
    }

    return (<td className="tdFitments">{fitmentDescription}</td>);
  };

  useEffect(() => {
    const numOfVehicles = vehicleList.length;

    if (numOfVehicles === 0) {
      const vehicleToAdd = {
        vehicleType: convertProperty(quote.vehicleType),
        insuranceOption: convertProperty(quote.insuranceOption),
        vehicleCondition: convertProperty(quote.vehicleCondition),
        makeModel: quote.makeModel,
        regNo: quote.regNo,
        fitments: quote.fitments
      }
      addRemoveVehicle(vehicleToAdd, "add");
    }
    // Remove the properties to make it easy parse the obj later
    delete quote.vehicleType;
    delete quote.insuranceOption;
    delete quote.vehicleCondition;
    delete quote.makeModel;
    delete quote.regNo;
    delete quote.fitments;
  }, []);

  useEffect(() => {
    console.log("effect ", vehicleList);
    const numOfVehicles = vehicleList.length;
    if (numOfVehicles < 2) {
      setNumberOfVehicles(numOfVehicles + " " + "vehicle");
    } else {
      setNumberOfVehicles(numOfVehicles + " " + "vehicles");
    }


  }, [vehicleList]);

  const removeVehicleFromList = (vehicle) => {
    addRemoveVehicle(vehicle, "remove");
  }

  return (
    <div className="formRouteMainContainer">
      <div className="formVehicleContainer">
        <div className="formVehicleHeader">
          <div className="formVehicleHeaderContent">{formHeading}</div>
        </div>
        <div className="formInfoContent">
          <div className="formInfoInputs">
            <div className="tableHeading">Overview ({numberOfVehicles})</div>
            <table>

              <tbody>
                {vehicleList.map((vehicle) => {
                  return (
                    <tr>
                      <td className="tdRegNo">{vehicle.regNo?.toUpperCase()}</td>
                      <td className="tdMakeModel">{vehicle.makeModel?.toUpperCase()}</td>
                      <td className="tdButton"><button onClick={() => removeVehicleFromList(vehicle)}>Remove</button></td>
                    </tr>
                  )

                })}

              </tbody>

            </table>

          </div>

          <div className="buttonSpacer"></div>
        </div>
        <div className="btn-container">
          <button className="btn-prev" onClick={prevStep}>
            Previous
          </button>
          <button className="btn-next" onClick={nextStep}>
            Continue
          </button>
        </div>

      </div>

    </div>
  );
}

export default FormVehicleOverview;
